export const MAX_FILE_SIZE = 5 * 1024 * 1024;

export const ALLOWED_MIME_TYPES = [
  'application/pdf',
  'text/plain',
  'application/vnd.ms-excel',
  'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
  'application/msword',
  'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
  'image/png',
  'image/jpeg',
];

export const ALLOWED_EXTENSIONS = '.pdf, .txt, .xls, .xlsx, .doc, .docx, .png, .jpg, .jpeg';

export const MIME_LABEL = {
  'application/pdf': 'PDF',
  'text/plain': 'TXT',
  'application/vnd.ms-excel': 'XLS',
  'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet': 'XLSX',
  'application/msword': 'DOC',
  'application/vnd.openxmlformats-officedocument.wordprocessingml.document': 'DOCX',
  'image/png': 'PNG',
  'image/jpeg': 'JPG',
};

export const ACCEPTED_FILE_TYPE_LABELS = [...Object.values(MIME_LABEL), 'JPEG'];

/** Distinct, accessible chip colors per file type (bg + text). */
export const CHIP_COLORS = {
  PDF:  { bg: '#fef2f2', color: '#b91c1c' },
  TXT:  { bg: '#f1f5f9', color: '#475569' },
  XLS:  { bg: '#ecfdf5', color: '#047857' },
  XLSX: { bg: '#d1fae5', color: '#065f46' },
  DOC:  { bg: '#eff6ff', color: '#1d4ed8' },
  DOCX: { bg: '#dbeafe', color: '#1e40af' },
  PNG:  { bg: '#f5f3ff', color: '#5b21b6' },
  JPG:  { bg: '#ede9fe', color: '#4c1d95' },
  JPEG: { bg: '#ede9fe', color: '#4c1d95' },
};

export const DUMMY_FILES = [
  {
    id: 'dummy-1',
    fileName: 'sprint-3-full-execution-report.pdf',
    fileDescription: 'Complete test execution report for Sprint 3 including pass/fail breakdown',
    fileType: 'application/pdf',
    fileSize: 512000,
    uploadedAt: '2026-01-08T09:30:00.000Z',
    updatedAt: '2026-01-09T08:15:00.000Z',
    uploadedBy: { id: 'u1', name: 'Alice Johnson' },
    updatedBy: { id: 'u2', name: 'Bob Smith' },
    folderName: 'Regression Tests / Sprint 3',
    duplicate: false,
  },
  {
    id: 'dummy-2',
    fileName: 'login-module-test-results.xlsx',
    fileDescription: 'Detailed results for all 47 login test cases in the Jan regression run',
    fileType: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
    fileSize: 78643,
    uploadedAt: '2026-01-14T14:20:00.000Z',
    updatedAt: '2026-01-14T14:20:00.000Z',
    uploadedBy: { id: 'u2', name: 'Bob Smith' },
    updatedBy: { id: 'u2', name: 'Bob Smith' },
    folderName: 'Regression Tests / Login Module',
    duplicate: false,
  },
  {
    id: 'dummy-3',
    fileName: 'checkout-flow-failure-screenshot.png',
    fileDescription: null,
    fileType: 'image/png',
    fileSize: 189440,
    uploadedAt: '2026-01-20T11:05:00.000Z',
    updatedAt: '2026-01-22T09:30:00.000Z',
    uploadedBy: { id: 'u3', name: 'Carol White' },
    updatedBy: { id: 'u1', name: 'Alice Johnson' },
    folderName: 'Smoke Tests',
    duplicate: false,
  },
  {
    id: 'dummy-4',
    fileName: 'api-gateway-execution.log.txt',
    fileDescription: 'Verbose execution log from the API gateway smoke test on staging',
    fileType: 'text/plain',
    fileSize: 24576,
    uploadedAt: '2026-01-25T16:45:00.000Z',
    updatedAt: '2026-01-25T16:45:00.000Z',
    uploadedBy: { id: 'u1', name: 'Alice Johnson' },
    updatedBy: { id: 'u1', name: 'Alice Johnson' },
    folderName: 'Smoke Tests',
    duplicate: true,
  },
  {
    id: 'dummy-5',
    fileName: 'regression-suite-summary-q1.xls',
    fileDescription: 'Q1 regression suite summary with coverage metrics and defect density',
    fileType: 'application/vnd.ms-excel',
    fileSize: 61440,
    uploadedAt: '2026-02-03T08:10:00.000Z',
    updatedAt: '2026-02-05T10:00:00.000Z',
    uploadedBy: { id: 'u2', name: 'Bob Smith' },
    updatedBy: { id: 'u3', name: 'Carol White' },
    folderName: 'Regression Tests',
    duplicate: false,
  },
  {
    id: 'dummy-6',
    fileName: 'payment-integration-test-run.pdf',
    fileDescription: 'Stripe and PayPal integration test results from the Feb 6 deployment',
    fileType: 'application/pdf',
    fileSize: 348160,
    uploadedAt: '2026-02-06T13:00:00.000Z',
    updatedAt: '2026-02-06T13:00:00.000Z',
    uploadedBy: { id: 'u4', name: 'David Lee' },
    updatedBy: { id: 'u4', name: 'David Lee' },
    folderName: 'Integration Tests / Payments',
    duplicate: false,
  },
  {
    id: 'dummy-7',
    fileName: 'ui-smoke-test-results.xlsx',
    fileDescription: 'Automated Playwright smoke test results across Chrome, Firefox and Safari',
    fileType: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
    fileSize: 95000,
    uploadedAt: '2026-02-10T10:30:00.000Z',
    updatedAt: '2026-02-11T09:00:00.000Z',
    uploadedBy: { id: 'u3', name: 'Carol White' },
    updatedBy: { id: 'u2', name: 'Bob Smith' },
    folderName: 'Smoke Tests',
    duplicate: false,
  },
  {
    id: 'dummy-8',
    fileName: 'null-pointer-error-screenshot.png',
    fileDescription: 'Screenshot captured during the NullPointerException in order summary page',
    fileType: 'image/png',
    fileSize: 142336,
    uploadedAt: '2026-02-12T15:20:00.000Z',
    updatedAt: '2026-02-12T15:20:00.000Z',
    uploadedBy: { id: 'u1', name: 'Alice Johnson' },
    updatedBy: { id: 'u1', name: 'Alice Johnson' },
    folderName: 'Integration Tests / Payments',
    duplicate: false,
  },
  {
    id: 'dummy-9',
    fileName: 'performance-baseline-notes.txt',
    fileDescription: null,
    fileType: 'text/plain',
    fileSize: 4096,
    uploadedAt: '2026-02-14T08:50:00.000Z',
    updatedAt: '2026-02-15T11:10:00.000Z',
    uploadedBy: { id: 'u4', name: 'David Lee' },
    updatedBy: { id: 'u3', name: 'Carol White' },
    folderName: 'Regression Tests / Sprint 3',
    duplicate: false,
  },
  {
    id: 'dummy-10',
    fileName: 'sprint-4-defect-triage.pdf',
    fileDescription: 'Defect triage output from the Sprint 4 review meeting — 12 bugs triaged',
    fileType: 'application/pdf',
    fileSize: 276480,
    uploadedAt: '2026-02-17T08:10:00.000Z',
    updatedAt: '2026-02-17T12:00:00.000Z',
    uploadedBy: { id: 'u2', name: 'Bob Smith' },
    updatedBy: { id: 'u1', name: 'Alice Johnson' },
    folderName: 'Regression Tests / Sprint 4',
    duplicate: false,
  },
];
